"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js");

require("core-js/modules/es.array.reduce.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildCategoryFlags = buildCategoryFlags;
exports.buildDestinationFlags = buildDestinationFlags;
exports.implyDestinationFlags = implyDestinationFlags;
exports.ManagerBuilder = ManagerBuilder;

var _react = require("react");

var _reactFastCompare = _interopRequireDefault(require("react-fast-compare"));

var _helpers = require("../../helpers");

var _preferences = require("./preferences");

var _integrations = require("./integrations");

var _analytics = _interopRequireDefault(require("./analytics"));

var _ = require("./");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function buildCategoryFlags(categories, destinationFlags) {
  return categories.reduce(function (flags, category) {
    flags[category.id] = category.destinationIDs.every(function (id) {
      return destinationFlags[id];
    });
    return flags;
  }, {});
}

function buildDestinationFlags(destinations, cookieDestinationFlags) {
  return destinations.reduce(function (flags, destination) {
    flags[destination.id] = destination.id in cookieDestinationFlags ? Boolean(cookieDestinationFlags[destination.id]) : false;
    return flags;
  }, {});
}

function implyDestinationFlags(categoryFlags) {
  var destinationFlags = {};

  _.categories.forEach(function (category) {
    category.destinationIDs.forEach(function (id) {
      return destinationFlags[id] = Boolean(categoryFlags[category.id]);
    });
  });

  return destinationFlags;
}

function ManagerBuilder() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$shouldRequireCon = _ref.shouldRequireConsent,
      shouldRequireConsent = _ref$shouldRequireCon === void 0 ? function () {
    return true;
  } : _ref$shouldRequireCon,
      children = _ref.children;

  var _reporter = (0, _helpers.reporter)(),
      info = _reporter.info,
      warn = _reporter.warn,
      table = _reporter.table;
  /*
    STATES
  */


  var _useReducer = (0, _react.useReducer)(function (oldState, newState) {
    return _objectSpread(_objectSpread({}, oldState), newState);
  }, {
    isLoading: true,
    allDestinations: [],
    newDestinations: [],
    destinationFlags: {},
    categoryFlags: {},
    isConsentRequired: true,
    haveFlagsChanged: false
  }),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      setState = _useReducer2[1];

  var _useReducer3 = (0, _react.useReducer)(function (oldState, newState) {
    return _objectSpread(_objectSpread({}, oldState), newState);
  }, {
    destinationFlags: {},
    categoryFlags: {}
  }),
      _useReducer4 = _slicedToArray(_useReducer3, 2),
      cookieState = _useReducer4[0],
      setCookieState = _useReducer4[1];
  /*
    ASYNC UPDATES
   */


  var cookiesOutdated = (0, _react.useRef)(false);
  var analyticsOutdated = (0, _react.useRef)(true);
  (0, _react.useEffect)(function () {
    if (state.isLoading) return;
    var allDestinations = state.allDestinations,
        destinationFlags = state.destinationFlags,
        isConsentRequired = state.isConsentRequired,
        shouldReload = state.haveFlagsChanged,
        categoryFlags = state.categoryFlags;

    if (cookiesOutdated.current) {
      cookiesOutdated.current = false;
      setCookieState({
        destinationFlags: destinationFlags,
        categoryFlags: categoryFlags
      });
      (0, _preferences.savePreferences)({
        destinationFlags: destinationFlags,
        categoryFlags: categoryFlags
      });
    }

    if (analyticsOutdated.current) {
      analyticsOutdated.current = false;
      (0, _analytics["default"])({
        writeKey: _.writeKey,
        allDestinations: allDestinations,
        destinationFlags: destinationFlags,
        isConsentRequired: isConsentRequired,
        shouldReload: shouldReload,
        categoryFlags: categoryFlags
      });
    }
  }, [state]);
  /*
    MAIN SETUP
   */

  (0, _react.useEffect)(function () {
    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var destinationFlags, categoryFlags, cookieValues, cookieDestinationFlags, _yield$Promise$all, _yield$Promise$all2, isConsentRequired, allDestinations, newDestinations;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              cookieValues = (0, _preferences.loadPreferences)({
                categories: _.categories
              });
              cookieDestinationFlags = cookieValues.destinationFlags;
              _context.next = 5;
              return Promise.all([shouldRequireConsent(), (0, _integrations.getIntegrations)(_.cdnHost, _.writeKey)]);

            case 5:
              _yield$Promise$all = _context.sent;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
              isConsentRequired = _yield$Promise$all2[0];
              allDestinations = _yield$Promise$all2[1];
              newDestinations = allDestinations.filter(function (destination) {
                return !(destination.id in cookieDestinationFlags);
              });
              destinationFlags = buildDestinationFlags(allDestinations, cookieDestinationFlags);
              categoryFlags = buildCategoryFlags(_.categories, destinationFlags);
              setCookieState(cookieValues);
              setState({
                isLoading: false,
                isConsentRequired: isConsentRequired,
                allDestinations: allDestinations,
                newDestinations: newDestinations,
                destinationFlags: destinationFlags,
                categoryFlags: categoryFlags
              });
              info('%csetup completed', 'color: blue; font-weight: bold;'); // table(cookieDestinationFlags);
              // table(newDestinations);

              _context.next = 20;
              break;

            case 17:
              _context.prev = 17;
              _context.t0 = _context["catch"](0);
              warn(_context.t0);

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 17]]);
    }))();
  }, []); // resetStateFromCookie

  function resetFromCookie() {
    var allDestinations = state.allDestinations;
    var cookieDestinationFlags = cookieState.destinationFlags;
    var destinationFlags, categoryFlags;
    destinationFlags = buildDestinationFlags(allDestinations, cookieDestinationFlags);
    categoryFlags = buildCategoryFlags(_.categories, destinationFlags);
    setState({
      destinationFlags: destinationFlags,
      categoryFlags: categoryFlags,
      haveFlagsChanged: false
    });
  } // saveStateToCookie


  function saveToCookie() {
    analyticsOutdated.current = true;
    cookiesOutdated.current = true;
    setState({
      newDestinations: [] // no more diff between stateFlags and cookieFlags !

    });
  }

  function setCategoryFlag(flag) {
    var categoryFlags = _objectSpread(_objectSpread({}, state.categoryFlags), flag);

    var destinationFlags = implyDestinationFlags(categoryFlags);
    var haveFlagsChanged = !(0, _reactFastCompare["default"])(destinationFlags, cookieState.destinationFlags);
    setState({
      categoryFlags: categoryFlags,
      destinationFlags: destinationFlags,
      haveFlagsChanged: haveFlagsChanged
    });
  }

  function setAllCategoryFlags(bool) {
    var categoryFlags = _.categories.reduce(function (obj, category) {
      obj[category.id] = Boolean(bool);
      return obj;
    }, {});

    var destinationFlags = implyDestinationFlags(categoryFlags);
    var haveFlagsChanged = !(0, _reactFastCompare["default"])(destinationFlags, cookieState.destinationFlags);
    setState({
      categoryFlags: categoryFlags,
      destinationFlags: destinationFlags,
      haveFlagsChanged: haveFlagsChanged
    });
  }

  if (state.isLoading) return null;
  return children(_objectSpread(_objectSpread({}, state), {}, {
    cookieDestinationFlags: cookieState.destinationFlags,
    cookieCategoryFlags: cookieState.categoryFlags,
    categories: _.categories,
    setCategoryFlag: setCategoryFlag,
    setAllCategoryFlags: setAllCategoryFlags,
    resetFromCookie: resetFromCookie,
    saveToCookie: saveToCookie
  }));
}